import { useState } from 'react';
import { Stack, Tab, Tabs } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { PortfolioCentralProductGetDetailResult } from '@mews-commander/data-access';
import { ProductSidePanelTabValues } from '../tables/CentralProductTable/types';
import { CentralProductDetails } from './CentralProductDetails';
import { CentralProductProperties } from './CentralProductProperties';

const DEFAULT_TAB = ProductSidePanelTabValues.Details;

interface ProductSidePanelTabsProps {
    selectedProduct: PortfolioCentralProductGetDetailResult;
    initialTab?: ProductSidePanelTabValues;
    assignedPropertyIds: string[];
}

export const CentralProductSidePanelTabs = ({
    selectedProduct,
    initialTab = DEFAULT_TAB,
    assignedPropertyIds,
}: ProductSidePanelTabsProps) => {
    const [activeTab, setActiveTab] = useState<ProductSidePanelTabValues>(initialTab);

    const content = {
        [ProductSidePanelTabValues.Details]: (
            <CentralProductDetails {...selectedProduct} productKey={selectedProduct.key} />
        ),
        [ProductSidePanelTabValues.Properties]: (
            <CentralProductProperties
                centralProductId={selectedProduct.id}
                centralProductName={selectedProduct.name}
                assignedPropertyIds={assignedPropertyIds}
            />
        ),
    };

    return (
        <Stack spacing="400" vertical>
            <Tabs
                inline
                activeTabValue={activeTab}
                onTabClick={(_, value) => setActiveTab(value as ProductSidePanelTabValues)}
                showDivider
            >
                <Tab
                    inline
                    id={ProductSidePanelTabValues.Details}
                    value={ProductSidePanelTabValues.Details}
                    label={lt('DetailPlural')}
                />
                <Tab
                    inline
                    id={ProductSidePanelTabValues.Properties}
                    value={ProductSidePanelTabValues.Properties}
                    label={lt('Properties')}
                />
            </Tabs>
            {content[activeTab]}
        </Stack>
    );
};
